import request from "@/utils/request";
let resquest = process.env.VUE_APP_BASE_API;

export default {
  /* ---------------------------------金手指相关接口---------------------------- */
  //主角自带
  zujiaozidai(params) {
    return request({
      url: `${resquest}/novel/app/goldfinger/innate`,
      method: "get",
      params,
    });
  },
  //后天获得
  houtianhuode(params) {
    return request({
      url: `${resquest}/novel/app/goldfinger/acquired`,
      method: "get",
      params,
    });
  },
  //获取内容
  getContent(data) {
    return request({
      url: `${resquest}/novel/app/goldfinger/content`,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      method: "post",
      data,
    });
  },
};
